<template>
  <ModalBase :closeBtn="true" @closed="emit('closed')">
    <div class="modal-video">
      <iframe
        :src="`https://www.youtube.com/embed/${src}?autoplay=1`"
        allow="autoplay"
        allowfullscreen=""
        frameborder="0"
        width="100%"
        height="100%"
      ></iframe>
      <IconLoader />
    </div>
  </ModalBase>
</template>

<script setup>
const props = defineProps(["src"]);
const emit = defineEmits(["closed"]);
</script>
